import { ActivityAPIModel, PaginatedAPI, activityTypes } from 'src/app/models/api.model'
import { ActivityDashboardModel } from 'src/app/models/model'

export interface ActivityState {
  dashboard: ActivityDashboardModel
  details: ActivityAPIModel
  summary: PaginatedAPI<ActivityAPIModel>
  types: any
  isPendingActivitesUpdated: boolean
}

export const initialActivityState: ActivityState = {
  dashboard: undefined,
  details: undefined,
  summary: undefined,
  types: undefined,
  isPendingActivitesUpdated: undefined
}
